//temporary place holder for navigation

import { RootState } from "app/store";
import ComparisonNavbar from "components/layout/ComparisonNavbar";
import { EViewType } from "global/Application";
import { appInsights } from "global/Application/AppInsight";
import { setViewType } from "global/Reducer/statusSlice";
import * as IRedirects from 'model/Redirect.type';
import { useEffect, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import EntryDialog, { EEntryDialogActions, EEntryDialogVariant } from "./EntryDialog";
import { ChainWithSchedule } from "global/Utility/TSFunctions";


interface IProps extends TComponentConnectedProps {
}


// TODO not sure what this component is intended to do, better to retire and use BlueRelationship context instead to handle the redirection and entry dialog for now until we have a better understanding of the requirements.
const BlueRelationship = (props: IProps) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [redirectRequest, setRedirectRequest] = useState<IRedirects.TRedirectRequest | null>(null);

    //TODO for now until things settle and are finalized.
    useEffect(() => {
        document.title = 'BlueRelationship';

        (async _ => {
            try {
                const redirected = props?.state?.router.location.query as IRedirects.TRedirectRequest;
                setRedirectRequest(redirected);
            } catch (error) {

            }
            finally {
            }
        })();

    }, []);



    const renderDialog = () => {

        if (!props.state.status.viewType)
            return (
                <EntryDialog
                    variant={redirectRequest?.accountId
                        ? EEntryDialogVariant.ViewMultipleConfig
                        : EEntryDialogVariant.Default
                    }
                    onConfirm={(action) => {

                        appInsights?.trackEvent({
                            name: 'BlueRelationship.EntryDialog.onConfirm',
                            properties: {
                                action: action,
                            }
                        });

                        if (redirectRequest) {

                            if (action === EEntryDialogActions.Compare) {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/comparison/${redirectRequest.accountId}/${redirectRequest.snapshot1Id}/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                            else if (action === EEntryDialogActions.CompareNew) {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/records/blueRelationship/${redirectRequest.accountId}/groupConfiguration/${redirectRequest.snapshot1Id}/compare/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                            else if (action === EEntryDialogActions.Merge) {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/merge/${redirectRequest.accountId}/${redirectRequest.snapshot1Id}/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                            else if (action === EEntryDialogActions.MergeNew) {
                                ChainWithSchedule(10,
                                    () => {
                                        dispatch(setViewType(EViewType.ViewOnly))
                                        debugger;
                                    },
                                    () => {
                                        const link = `/records/blueRelationship/${redirectRequest.accountId}/groupConfiguration/${redirectRequest.snapshot1Id}/merge/${redirectRequest.snapshot2Id}`
                                        history.push(link);
                                    }
                                );
                            }
                            else if (action === EEntryDialogActions.UnderwritingReviewLegacy) {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/underwritingReview/${redirectRequest.accountId}/${redirectRequest.snapshot1Id}/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                            else if (action === EEntryDialogActions.UnderwritingReviewNew) {
                                dispatch(setViewType(EViewType.ViewOnly))
                                setTimeout(() => {

                                    const link = `${redirectRequest.accountId}/groupConfiguration/${redirectRequest.snapshot1Id}/underwriting/${redirectRequest.snapshot2Id}`
                                    history.push(link);
                                }, 1000)
                            }
                        }
                    }}
                />
            );
    }

    return (
        <div>
            <ComparisonNavbar />
            {props?.state?.status?.account?.name}
            {renderDialog()}

        </div>
    );
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(BlueRelationship);